import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { ControlContainer } from 'app/components/ControlContainer';
import { UtilService } from 'app/services/util.service';
import { SkpNumberControlProps } from './SkpNumberControl.interfaces';
import { useTextControl } from 'app/shared/hooks/controls/useTextControl';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { ControlLabelEnum } from 'app/shared/enums';

const getUpperCasedValue = (value: string) => {
  return value.toUpperCase();
};

const validChars = (value: string) => {
  return /^[A-Z0-9/]+$/i.test(value);
};

export default function SkpNumberControl(props: SkpNumberControlProps) {
  const {
    disabled,
    input,
    meta,
    label,
    subLabel,
    helperText,
    tooltip,
    width,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    isValueCheckVisible,
    onFocus,
  } = useTextControl(props, {
    charValidation: validChars,
    valueNormalize: getUpperCasedValue,
  });

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      helperText={helperText}
      isQuestionValid={props.isQuestionValid}
      floating
      floated={focused || UtilService.hasValue(input.value)}
      meta={meta}
      focused={focused}
      width={width}
    >
      <FormControl fullWidth>
        <TextField
          {...input}
          id={input.name}
          label={subLabel ? `${label} - ${subLabel}` : label}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={onFocus}
          inputProps={{
            maxLength: 12,
          }}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          InputProps={{
            startAdornment: isValueCheckVisible && <DoneAdornment />,
          }}
          error={error}
          variant={'outlined'}
          margin={'dense'}
          disabled={disabled}
          placeholder={ControlLabelEnum.SkpNumberPlaceholder}
        />
      </FormControl>
    </ControlContainer>
  );
}
